<template>
    <div></div>
</template>

<script>
    import { EventBus } from "../../../eventBus";

    export default {
        props: ['topic', 'route'],
        data: function () {
            return {}
        },
        mounted: function () {
            axios.post(this.route, {})
                .then((res)=> {
                    EventBus.emit('topicRead', { unreadMessagesCount: res.data.unreadMessagesCount, infoMessage: res.data.infoMessage, topicId: res.data.topicId });
                });
        }
    }
</script>